var _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIllution4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 732,
    height: 4,
    viewBox: "0 0 732 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 129,
    width: 340,
    height: 4,
    rx: 2,
    fill: "#FFA412"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 502,
    width: 230,
    height: 4,
    rx: 2,
    fill: "#40805C"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 97,
    height: 4,
    rx: 2,
    fill: "#40805C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllution4);
export default __webpack_public_path__ + "static/media/illution_4.0c4600860674ac76d1df1c9a6730cdc7.svg";
export { ForwardRef as ReactComponent };